import { render, staticRenderFns } from "./FieldWithSeperateStylesEdit.vue?vue&type=template&id=1da8bf44"
import script from "./FieldWithSeperateStylesEdit.vue?vue&type=script&lang=ts"
export * from "./FieldWithSeperateStylesEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1da8bf44')) {
      api.createRecord('1da8bf44', component.options)
    } else {
      api.reload('1da8bf44', component.options)
    }
    module.hot.accept("./FieldWithSeperateStylesEdit.vue?vue&type=template&id=1da8bf44", function () {
      api.rerender('1da8bf44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/FieldWithSeperateStylesEdit.vue"
export default component.exports